import { Record, List, fromJS } from 'immutable'
import _ from 'lodash'

import { LOAD_FAVOURITES_REQUEST, LOAD_FAVOURITES_REQUEST_SUCCESS, FAVOURITES_LOADED } from './constants'

const initialState = Record({
    loading: false,
    loaded: false,
    entities: List(),
})

export default function favouritesReducer(state = initialState(), action = {}) {
    switch (action.type) {
        case LOAD_FAVOURITES_REQUEST: {
            return state.set('loading', true).set('loaded', false)
        }

        case LOAD_FAVOURITES_REQUEST_SUCCESS: {
            return state.set('loading', false).set('loaded', true)
        }
        case FAVOURITES_LOADED: {
            const entities = fromJS(_.get(action, 'data.entities', []))

            return state.set('entities', entities)
        }
        default:
            return state
    }
}
